<template>
    <div class="repair-container" ref="container">
        <div class="car-container">
            <div style="font-size: 21px;display: inline-block;color: #044aa1;font-weight: bold">
                {{ memberInfo.name }}
            </div>
            <div class="flag-order-number"></div>
            <div class="title-order-number">
                电话号码:
                <span class="value-order-number">
                    {{ memberInfo.phone }}
                </span>
            </div>
            <div class="back-button" @click="onClose()">
                <Icon type="md-close"/>
                <span>关闭</span>
            </div>
        </div>
        <div class="receive-title">护理项目和材料</div>
        <div style="padding: 0 10px">
            <Button v-if="canEdit()" type="primary" size="small" style="font-size: 13px" @click="clickChooseItem">选择项目</Button>
        </div>
        <div v-if="forceUpdate">
            <Row class="item-container" v-for="(item, index) in itemList" :key="item.id">
                <Col span="10">
                    <div class="item-content item-background">
                        <div class="item-title">
                            <span>{{ index + 1 }}、{{ item.name }}</span>
                            <Poptip
                                v-if="canEdit()"
                                confirm
                                title="确定删除?"
                                @on-ok="removeItem(item)" placement="top-start" transfer style="float: right">
                                <span class="item-remove-button">删除</span>
                            </Poptip>
                        </div>
                        <div class="item-price">
                            <div v-if="item.priceMethod === 1">
                                <Row>
                                    <Col span="4" class="item-price-child">
                                        {{ item.preManhour }}
                                    </Col>
                                    <Col span="4" class="item-price-child">
                                        x
                                    </Col>
                                    <Col span="4" class="item-price-child">
                                        {{ item.unitPrice }}
                                    </Col>
                                    <Col span="4" class="item-price-child">
                                        =
                                    </Col>
                                    <Col span="4" class="item-price-child">
                                        {{ item.totalPrice }}
                                    </Col>
                                    <Col span="4" class="item-price-child">
                                        {{ item.totalPrice }}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span="4" class="item-price-child" style="font-size: 12px">
                                        工时
                                    </Col>
                                    <Col span="4" class="item-price-child"></Col>
                                    <Col span="4" class="item-price-child" style="font-size: 12px">
                                        单价
                                    </Col>
                                    <Col span="4" class="item-price-child"></Col>
                                    <Col span="4" class="item-price-child" style="font-size: 12px">
                                        原价
                                    </Col>
                                    <Col span="4" class="item-price-child" style="font-size: 12px">
                                        销售价
                                    </Col>
                                </Row>
                            </div>
                            <div v-else>
                                <Row>
                                    <Col span="5" class="item-price-child">
                                        {{ item.totalPrice }}
                                    </Col>
                                    <Col span="5" class="item-price-child">
                                        <Input v-if="item.actualTotalPriceShow" type="number" v-model="item.actualTotalPrice"
                                               style="width: 70px"
                                               @on-enter="onMoneyEnter(item.actualTotalPrice)"
                                               @on-keydown="onMoneyKeyPress"/>
                                        <span v-else>￥{{ item.actualTotalPrice }}</span>
                                        <Icon v-if="item.actualTotalPriceShow" class="icon-save-class" type="md-checkmark"
                                              @click="onMoneyEnter(item.actualTotalPrice)"/>
                                        <span v-else>
                                            <Icon v-if="canEdit()" class="icon-edit-class" type="ios-create-outline"
                                                  @click="showItemPriceInput(item)"/>
                                        </span>
                                    </Col>
                                    <Col span="2" class="item-price-child" style="font-size: 12px">
                                        x
                                    </Col>
                                    <Col span="5" class="item-price-child" style="font-size: 12px">
                                        <Input v-if="item.countShow" type="number" v-model="item.count"
                                               style="width: 70px"
                                               @on-enter="onCountEnter(item.count)"
                                               @on-keydown="onCountKeyPress"/>
                                        <span v-else style="position: relative;top: 1px;">{{ item.count }}</span>
                                        <Icon v-if="item.countShow" class="icon-save-class" type="md-checkmark"
                                              @click="onCountEnter(item.count)"/>
                                        <span v-else>
                                            <Icon v-if="canEdit()" class="icon-edit-class" type="ios-create-outline"
                                                  @click="showItemCountInput(item)"/>
                                        </span>
                                    </Col>
                                    <Col span="2" class="item-price-child" style="font-size: 12px">
                                        =
                                    </Col>
                                    <Col span="5" class="item-price-child font-bold">
                                        ￥{{ getItemTotalPrice(item) }}
                                    </Col>
                                </Row>
                                <Row style="margin-top: 5px">
                                    <Col span="5" class="item-price-child" style="font-size: 12px">
                                        原单价
                                    </Col>
                                    <Col span="5" class="item-price-child" style="font-size: 12px">
                                        销售单价
                                    </Col>
                                    <Col span="2" class="item-price-child" style="font-size: 12px">
                                    </Col>
                                    <Col span="5" class="item-price-child" style="font-size: 12px">
                                        数量
                                    </Col>
                                    <Col span="2" class="item-price-child" style="font-size: 12px">
                                    </Col>
                                    <Col span="5" class="item-price-child font-bold">
                                        项目总价
                                    </Col>
                                </Row>
                            </div>
                            <Row style="margin: 10px 0 5px 0">
                                <Col span="8" class="item-price-child" style="font-size: 13px;color: #505050">
                                </Col>
                                <Col span="16" class="item-price-child">
                                    <div v-if="item.userInfoList && item.userInfoList.length > 0" class="already-worker">
                                        <span style="font-weight: bold;color: #202020">护理人员：</span>
                                        <span>{{ item.userInfoList.map(u => u.name).join(', ') }}</span>
                                    </div>
                                    <span v-else>
                                        <div v-if="canEdit()" class="unset-worker">未安排护理师</div>
                                    </span>
                                </Col>
                            </Row>
                        </div>
                        <div class="item-footer">
                            <span v-if="canEdit()" class="footer-button" @click="showDispatch(item)">安排护理师</span>
                            <span v-if="canEdit()" class="footer-button" @click="clickChooseMater(item)">选择材料</span>
                        </div>
                    </div>
                </Col>
                <Col span="14" style="padding: 0 10px" class="item-background">
                    <Row>
                        <Col class="mater-title" span="8">材料名称</Col>
                        <Col class="mater-title" span="5">数量</Col>
                        <Col class="mater-title" span="5">售价</Col>
                        <Col class="mater-title" span="4">操作</Col>
                    </Row>
                    <div style="background: #a3a7af; height: 1px;margin-bottom: 8px"></div>
                    <div v-if="item.materialsInfoList" style="margin-bottom: 20px">
                        <Row v-for="mater in item.materialsInfoList" :key="mater.id" style="margin-top: 5px">
                            <Col class="mater-text" span="8">{{ mater.name }}</Col>
                            <Col class="mater-text" span="5">
                                <Input v-if="mater.countShow" type="number" v-model="mater.count"
                                       style="width: 70px"
                                       @on-enter="onCountEnter(mater.count)"
                                       @on-keydown="onCountKeyPress"/>
                                <span v-else style="position: relative;top: 1px;">{{ mater.count }}</span>
                                <Icon v-if="mater.countShow" class="icon-save-class" type="md-checkmark"
                                      @click="onCountEnter(mater.count)"/>
                                <span v-else>
                                    <Icon v-if="canEdit()" class="icon-edit-class"
                                          type="ios-create-outline" @click="showCountInput(mater)"/>
                                </span>
                            </Col>
                            <Col class="mater-text" span="5">
                                <Input v-if="mater.moneyShow" type="number" v-model="mater.actualSellPrice"
                                       style="width: 80px"
                                       @on-enter="onMoneyEnter(mater.actualSellPrice)"
                                       @on-keydown="onMoneyKeyPress"/>
                                <span v-else style="position: relative;top: 1px;">￥{{ mater.actualSellPrice }}</span>
                                <Icon v-if="mater.moneyShow" class="icon-save-class" type="md-checkmark"
                                      @click="onMoneyEnter(mater.actualSellPrice)"/>
                                <span v-else>
                                    <Icon v-if="canEdit()" class="icon-edit-class" type="ios-create-outline"
                                          @click="showMoneyInput(mater)"/>
                                </span>

                            </Col>
                            <Col class="mater-text" span="4">
                                <Poptip
                                    v-if="canEdit()"
                                    confirm
                                    title="确定删除?"
                                    @on-ok="removeItemMater(item, mater)" placement="top-start" transfer>
                                    <span class="mater-remove-button">删除</span>
                                </Poptip>
                            </Col>
                        </Row>
                        <div>
                            <Row style="margin-top: 30px">
                                <Col span="8"></Col>
                                <Col span="16">
                                    <Row>
                                        <Col class="calc-title" span="6">项目费</Col>
                                        <Col class="calc-title" span="2"></Col>
                                        <Col class="calc-title" span="6">材料费</Col>
                                        <Col class="calc-title" span="2"></Col>
                                        <Col class="calc-title" span="8">小计</Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row style="margin-top: 5px">
                                <Col span="8"></Col>
                                <Col span="16">
                                    <div style="background: #4b586b; height: 1px"></div>
                                </Col>
                            </Row>
                            <Row style="margin-top: 5px">
                                <Col span="8"></Col>
                                <Col span="16">
                                    <Row>
                                        <Col class="calc-text" span="6">￥{{ getItemTotalPrice(item) }}</Col>
                                        <Col class="calc-text" span="2">+</Col>
                                        <Col class="calc-text" span="6">￥{{ calcMaterPrice(item) }}</Col>
                                        <Col class="calc-text" span="2">=</Col>
                                        <Col class="calc-text" span="8">￥{{ calcPartPrice(item) }}</Col>
                                    </Row>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </Col>
                <div style="background: #cdd2d9; height: 1px; width: 100%;margin: 10px 0 20px 0"></div>
            </Row>
            <div class="footer-container">
                <span class="footer-title">项目护理费：</span>
                <span class="footer-value">￥{{ getWorkPrice() }}</span>
                <span class="footer-title">护理材料费：</span>
                <span class="footer-value">￥{{ getMaterPrice() }}</span>
                <span class="footer-title">总计：</span>
                <span class="footer-value">￥{{ getTotalPrice() }}</span>
                <div v-if="orderInfo.status === 0 || orderInfo.status === 2" class="footer-settlement-button"
                     @click="saveOrderItem(2)">
                    <span>提交</span>
                </div>
            </div>
        </div>
        <Modal
            fullscreen
            v-model="showItemSelect"
            :closable="false"
            footer-hide>
            <div>
                <choose-item v-if="showItemSelect" @handleClose="handleChooseClose"></choose-item>
            </div>
        </Modal>
        <Modal
            fullscreen
            v-model="showMaterSelect"
            :closable="false"
            footer-hide>
            <div>
                <choose-mater v-if="showMaterSelect" @handleClose="handleMaterClose"></choose-mater>
            </div>
        </Modal>
        <Modal
            fullscreen
            :closable="false"
            title="安排护理师"
            v-model="dispatchModal"
            footer-hide>
            <div>
                <dispatch-work v-if="dispatchModal" :itemInfo="currentItem" @handleClose="handleDispatchClose"></dispatch-work>
            </div>
        </Modal>
        <Modal
            title="结算"
            draggable
            sticky
            :closable="false"
            footer-hide
            :mask-closable="false"
            v-model="settlementModal">
            <div>
                <Row>
                    <Col class="price-text" span="6">
                        {{ getWorkPrice() }}
                    </Col>
                    <Col class="price-text" span="3">
                        +
                    </Col>
                    <Col class="price-text" span="6">
                        {{ getMaterPrice() }}
                    </Col>
                    <Col class="price-text" span="3">
                        =
                    </Col>
                    <Col class="price-text" span="6">
                        {{ getTotalPrice() }}
                    </Col>
                </Row>
                <Row style="margin-bottom: 15px">
                    <Col class="price-desc" span="6">
                        工时费
                    </Col>
                    <Col class="price-desc" span="3"></Col>
                    <Col class="price-desc" span="6">
                        材料费
                    </Col>
                    <Col class="price-desc" span="3"></Col>
                    <Col class="price-desc" span="6">
                        工单金额
                    </Col>
                </Row>
                <div class="settle-line"></div>
                <div style="margin-top: 15px;font-size: 13px">
                    <span class="settle-info-title">折后工时费：</span>
                    <span style="color: #000000;margin-right: 3px">{{ getDiscountWorkPrice() }}</span>
                    <div style="display: inline-block;margin-left: 5px" v-if="discountWorkShow">
                        <Input type="number" v-model="settleForm.discountWorkValue"
                               class="discount-input"
                               :border="false"
                               @on-keydown="discountInputKeyDown"/>
                        <div class="percent-container">%</div>
                        <Icon class="icon-save-class" type="md-checkmark" @click="saveDiscountWork()"/>
                    </div>
                    <div style="display: inline-block" v-else>
                        <span style="color: #7c7c7c">(折扣{{ settleForm.discountWorkValue }}%)</span>
                        <span class="discount-button" @click="discountWorkShow=true">设置折扣</span>
                    </div>
                </div>
                <div style="margin: 15px 0;font-size: 13px">
                    <span class="settle-info-title">折后材料费：</span>
                    <span style="color: #000000;margin-right: 3px">{{ getDiscountMaterPrice() }}</span>
                    <div style="display: inline-block;margin-left: 5px" v-if="discountMaterShow">
                        <Input type="number" v-model="settleForm.discountMaterValue"
                               class="discount-input"
                               :border="false"
                               @on-keydown="discountInputKeyDown"/>
                        <div class="percent-container">%</div>
                        <Icon class="icon-save-class" type="md-checkmark" @click="saveDiscountMater()"/>
                    </div>
                    <div style="display: inline-block" v-else>
                        <span style="color: #7c7c7c">(折扣{{ settleForm.discountMaterValue }}%)</span>
                        <span class="discount-button" @click="discountMaterShow=true">设置折扣</span>
                    </div>
                </div>
                <div class="settle-line"></div>
                <Row style="margin: 15px 0;font-size: 13px">
                    <Col span="9">
                        <div>
                            <span class="settle-info-title">应收金额：</span>
                            <span style="color: #ff0000;margin-right: 3px;font-weight: bold">￥{{ getReceivablePrice() }}</span>
                        </div>
                    </Col>
                </Row>
                <Row style="margin: 15px 0;font-size: 13px">
                    <Col span="12">
                        <div>
                            <span class="settle-info-title">出厂里程(KM)：</span>
                            <Input style="display: inline-block;width: 120px" type="number" v-model="settleForm.exitMileage"/>
                        </div>
                    </Col>
                    <Col span="12" style="text-align: right">
                        <div>
                            <span class="settle-info-title">结算时间：</span>
                            <DatePicker style="width: 172px" type="datetime" format="yyyy-MM-dd HH:mm:ss"
                                        v-model="settleForm.defaultSettleTime"
                                        placeholder="请选择接车时间" class="my-form-input" @on-change="handleSettleChange"/>
                        </div>
                    </Col>
                    <div class="settle-info-title" style="margin: 8px 0 5px 0">结算备注：</div>
                    <Input v-model="settleForm.settleRemark" placeholder="请输入结算备注" type="textarea"
                           maxlength="500" show-word-limit></Input>
                </Row>
                <div style="text-align: right;margin-top: 20px">
                    <span v-if="discountMaterShow || discountWorkShow"
                          style="margin-right: 10px;font-size: 12px;color: #ff0000">折扣设置保存后才能结算</span>
                    <Button style="margin-right: 10px" @click="cancelSettle()">取消</Button>
                    <Button type="primary" :disabled="discountMaterShow || discountWorkShow" @click="saveSettle()">确定结算</Button>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
import {
    cancelSettleOrder,
    removeOrderItem,
    removeOrderItemMater,
    settleOrder,
} from "@/api/business"
import ChooseItem from "@/components/BaseData/ChooseItem"
import ChooseMater from "@/components/BaseData/ChooseMater"
import DispatchWork from "@/components/Business/DispatchWork"
import Decimal from "decimal.js"
import {queryFacialOrderDetail, saveFacialOrderDetail} from "@/api/facial"

export default {
    name: "RepairInfo",
    components: {
        ChooseItem,
        ChooseMater,
        DispatchWork,
    },
    props: {
        memberInput: {
            type: Object,
            default: () => ({}),
        },
        orderInput: {
            type: Object,
            default: () => ({
                status: 0,
            }),
        },
        isNew: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            orderInfo: {
                orderNumber: '',
            },
            memberInfo: {},
            showItemSelect: false,
            itemList: [],
            showMaterSelect: false,
            currentItem: {},
            forceUpdate: true,
            dispatchModal: false,
            settlementModal: false,
            discountWorkShow: false,
            discountMaterShow: false,
            settleForm: {
                discountWorkValue: 100,
                discountMaterValue: 100,
                defaultSettleTime: new Date(),
                settleTime: '',
                settleRemark: '',
                exitMileage: '',
            },
        }
    },
    mounted() {
        this.initInfo()
    },
    methods: {
        initInfo() {
            this.orderInfo = Object.assign({}, this.orderInput)
            this.memberInfo = Object.assign({}, this.memberInput)
            if (this.orderInfo.id) {
                queryFacialOrderDetail(this.orderInfo).then((res) => {
                    this.orderInfo = res.data.facialOrder
                    this.memberInfo = res.data.memberInfo
                    this.itemList = res.data.itemInfoList
                })
            }
            this.$refs.container.parentElement.parentElement.style.padding = '0px'
        },
        showDispatch(item) {
            this.currentItem = item
            this.dispatchModal = true
        },
        clickChooseItem() {
            this.showItemSelect = true
        },
        clickChooseMater(item) {
            this.currentItem = item
            this.showMaterSelect = true
        },
        handleChooseClose(data) {
            if (data) {
                let changed = false
                for (let item of data) {
                    if (!this.isExist(this.itemList, item)) {
                        if (!item.actualTotalPrice) {
                            item.actualTotalPrice = item.totalPrice
                        }
                        this.itemList.push(item)
                        changed = true
                    }
                }
                if (changed) {
                    this.saveOrderItem()
                    this.showItemSelect = false
                } else {
                    this.showItemSelect = false
                }
            } else {
                this.showItemSelect = false
            }
        },
        handleMaterClose(data) {
            if (!this.currentItem.id) {
                return
            }
            if (data) {
                let changed = false
                for (let item of data) {
                    if (!this.isExist(this.currentItem.materialsInfoList, item)) {
                        this.currentItem.materialsInfoList.push(item)
                        changed = true
                    }
                }
                if (changed) {
                    this.saveOrderItem()
                    this.showMaterSelect = false
                } else {
                    this.showMaterSelect = false
                }
            } else {
                this.showMaterSelect = false
            }
        },
        handleDispatchClose(data) {
            if (!this.currentItem.id) {
                return
            }
            if (data) {
                this.currentItem.userInfoList = data
                this.saveOrderItem()
                this.dispatchModal = false
            } else {
                this.dispatchModal = false
            }
        },
        saveOrderItem(status) {
            if (status) {
                this.orderInfo.status = status
            }
            let param = {
                facialOrder: this.orderInfo,
                memberInfo: this.memberInfo,
                itemInfoList: this.itemList,
            }
            saveFacialOrderDetail(param).then((res) => {
                this.itemList = res.data.itemInfoList
                this.orderInfo = res.data.facialOrder
                if (status) {
                    this.$Message.success({
                        background: true,
                        content: '提交成功',
                    })
                    if (this.isNew) {
                        this.$router.push({name: 'facialOrderCashier'})
                    } else {
                        this.onClose()
                    }
                }
            }).catch(() => {
                this.itemList = []
            }).finally(() => {
                this.showMaterSelect = false
                this.showItemSelect = false
                this.forceUpdate = false
                this.forceUpdate = true
            })
        },
        isExist(list, data) {
            for (let item of list) {
                if (item.id === data.id) {
                    return true
                }
            }
            return false
        },
        getItemTotalPrice(item) {
            return Number(new Decimal(item.actualTotalPrice).mul(new Decimal(item.count))).toFixed(2)
        },
        calcMaterPrice(item) {
            let materPrice = new Decimal(0)
            for (let mater of item.materialsInfoList) {
                let itemPrice = new Decimal(mater.count).mul(mater.actualSellPrice)
                materPrice = materPrice.add(itemPrice)
            }
            return materPrice
        },
        calcPartPrice(item) {
            return Number(this.calcMaterPrice(item).add(new Decimal(item.totalPrice))).toFixed(2)
        },
        removeItem(item) {
            let param = {orderId: this.orderInfo.id, itemId: item.id}
            removeOrderItem(param).then((res) => {
                if (res && res.data) {
                    for (let i = 0; i < this.itemList.length; i++) {
                        if (item.id === this.itemList[i].id) {
                            this.itemList.splice(i, 1)
                            break
                        }
                    }
                    this.$Message.success({
                        background: true,
                        content: '删除完成',
                    })
                }
            })
        },
        removeItemMater(item, mater) {
            let param = {orderId: this.orderInfo.id, itemId: item.id, materialsId: mater.id}
            removeOrderItemMater(param).then((res) => {
                if (res && res.data) {
                    for (let i = 0; i < item.materialsInfoList.length; i++) {
                        if (mater.id === item.materialsInfoList[i].id) {
                            item.materialsInfoList.splice(i, 1)
                            break
                        }
                    }
                    this.$Message.success({
                        background: true,
                        content: '删除完成',
                    })
                }
            })
        },
        showCountInput(mater) {
            mater.countShow = true
            this.$forceUpdate()
        },
        showItemCountInput(item) {
            item.countShow = true
            this.$forceUpdate()
        },
        showItemPriceInput(item) {
            item.actualTotalPriceShow = true
            this.$forceUpdate()
        },
        showMoneyInput(mater) {
            mater.moneyShow = true
            this.$forceUpdate()
        },
        onCountEnter(count) {
            const value = count
            // 1. 检查是否为空
            if (value === "") {
                this.$Message.warning({
                    background: true,
                    content: '数量不能为空',
                })
                return
            }

            // 2. 检查是否为正整数（正则：1-9开头，后续可跟任意数字，且不能有小数点）
            const regex = /^(0|[1-9]\d*)$/
            if (!regex.test(value)) {
                this.$Message.warning({
                    background: true,
                    content: '数量只能填入正整数',
                })
            } else {
                this.saveOrderItem()
            }
        },
        onMoneyEnter(price) {
            const value = price
            // 1. 检查是否为空
            if (value === "") {
                this.$Message.warning({
                    background: true,
                    content: '售价不能为空',
                })
                return
            }

            // 2. 检查是否为正整数（正则：1-9开头，后续可跟任意数字，且不能有小数点）
            const regex = /^(?!0\d)\d+(\.\d{1,2})?$/
            if (!regex.test(value)) {
                this.$Message.warning({
                    background: true,
                    content: '售价只能数据数字，最多两位小数',
                })
            } else {
                this.saveOrderItem()
            }
        },
        onCountKeyPress(event) {
            const alwaysAllowedKeys = ["Backspace", "Tab", "Enter"]
            if (alwaysAllowedKeys.includes(event.key)) {
                return
            }
            if (!/[0-9]/.test(event.key)) {
                event.preventDefault()
            }
        },
        onMoneyKeyPress(event) {
            const key = event.key
            let currentValue = event.target.value
            // 允许的按键：数字（0-9）、小数点（.）、退格（Backspace）
            const allowedKeys = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "."]
            const alwaysAllowedKeys = ["Backspace", "Tab", "Enter"]
            if (alwaysAllowedKeys.includes(key)) {
                return
            }
            // 如果按下的键不在允许范围内，阻止输入
            if (!allowedKeys.includes(key)) {
                event.preventDefault()
                return
            }

            // 如果输入的是小数点（.），检查是否已经存在小数点
            if (key === ".") {
                if (currentValue.includes(".")) {
                    event.preventDefault()
                    return
                }
            }

            // 如果已经输入了小数点，检查是否超过两位小数
            if (currentValue.includes(".")) {
                const decimalPart = currentValue.split(".")[1]
                if (decimalPart && decimalPart.length >= 2) {
                    event.preventDefault()
                }
            }
        },
        getWorkPrice() {
            let price = new Decimal(0)
            for (let item of this.itemList) {
                price = price.add(new Decimal(item.count).mul(new Decimal(item.actualTotalPrice)))
            }
            return price
        },
        getMaterPrice() {
            let price = new Decimal(0)
            for (let item of this.itemList) {
                if (!item.materialsInfoList) {
                    continue
                }
                for (let mater of item.materialsInfoList) {
                    price = price.add(new Decimal(mater.count).mul(new Decimal(mater.actualSellPrice)))
                }
            }
            return price
        },
        getDiscountWorkPrice() {
            // return Number(this.getWorkPrice() * this.settleForm.discountWorkValue / 100).toFixed(2)
            return Number(this.getWorkPrice().mul(this.settleForm.discountWorkValue).div(100)).toFixed(2)
        },
        getDiscountMaterPrice() {
            // return Number(this.getMaterPrice() * this.settleForm.discountMaterValue / 100).toFixed(2)
            return Number(this.getMaterPrice().mul(this.settleForm.discountMaterValue).div(100)).toFixed(2)
        },
        getTotalPrice() {
            return this.getWorkPrice().add(this.getMaterPrice())
        },
        getReceivablePrice() {
            // return Number(this.getDiscountWorkPrice()) + Number(this.getDiscountMaterPrice())
            return Number(new Decimal(this.getDiscountWorkPrice()).add(new Decimal(this.getDiscountMaterPrice()))).toFixed(2)
        },
        settlementClick() {
            this.settlementModal = true
            this.settleForm.exitMileage = this.orderInfo.exitMileage
            this.settleForm.settleRemark = this.orderInfo.settleRemark
        },
        cancelSettlementClick() {
            cancelSettleOrder({id: this.orderInfo.id}).then((res) => {
                this.orderInfo = res.data
                this.cancelSettle()
                this.$Message.success({
                    background: true,
                    content: '取消结算完成',
                })
            })
        },
        saveDiscountWork() {
            if (this.settleForm.discountWorkValue === '') {
                this.settleForm.discountWorkValue = 100
                this.discountWorkShow = false
                return
            }
            let value = Number(this.settleForm.discountWorkValue)
            if (value >= 0 && value <= 100) {
                this.discountWorkShow = false
            } else {
                this.$Message.warning({
                    background: true,
                    content: '折扣只能输入数字0-100内数字',
                })
            }
        },
        saveDiscountMater() {
            if (this.settleForm.discountMaterValue === '') {
                this.settleForm.discountMaterValue = 100
                this.discountMaterShow = false
                return
            }
            let value = Number(this.settleForm.discountMaterValue)
            if (value >= 0 && value <= 100) {
                this.discountMaterShow = false
            } else {
                this.$Message.warning({
                    background: true,
                    content: '折扣只能输入数字0-100内数字',
                })
            }
        },
        discountInputKeyDown(event) {
            let currentValue = event.target.value
            const value = event.key
            const alwaysAllowedKeys = ["Backspace", "Tab", "Enter"]
            if (alwaysAllowedKeys.includes(value)) {
                return
            }
            if (!/[0-9]/.test(event.key)) {
                event.preventDefault()
                return
            }
            const num = parseInt(`${currentValue}${value}`, 10)
            if (num < 0 || num > 1000) {
                event.preventDefault()
            }
        },
        handleSettleChange(date) {
            this.settleForm.settleTime = date
        },
        cancelSettle() {
            this.settlementModal = false
            this.discountWorkShow = false
            this.discountMaterShow = false
            this.settleForm = {
                discountWorkValue: 100,
                discountMaterValue: 100,
                defaultSettleTime: new Date(),
                settleTime: '',
                settleRemark: '',
                exitMileage: '',
            }
        },
        saveSettle() {
            this.orderInfo.discountWork = this.settleForm.discountWorkValue
            this.orderInfo.discountMater = this.settleForm.discountMaterValue
            this.orderInfo.settleTime = this.settleForm.settleTime
            this.orderInfo.settleRemark = this.settleForm.settleRemark
            this.orderInfo.exitMileage = this.settleForm.exitMileage
            this.orderInfo.workPrice = this.getWorkPrice()
            this.orderInfo.materPrice = this.getMaterPrice()
            this.orderInfo.totalPrice = this.getTotalPrice()
            this.orderInfo.discountWorkPrice = this.getDiscountWorkPrice()
            this.orderInfo.discountMaterPrice = this.getDiscountMaterPrice()
            this.orderInfo.receivablePrice = this.getReceivablePrice()
            settleOrder(this.orderInfo).then((res) => {
                this.orderInfo = res.data
                this.$Message.success({
                    background: true,
                    content: '结算完成',
                })
                this.cancelSettle()
                this.$router.push({path: '/orderCashier'})
            })
        },
        canEdit() {
            return this.orderInfo.status === 0 || this.orderInfo.status === 2
        },
        onClose() {
            this.$emit('handleEditClose', false)
        },
    },
}
</script>

<style scoped>
.repair-container {
    padding: 10px;
    background: #fefefe;
    height: 100%;
    overflow-y: auto;
    position: relative;
}

.flag-order-number {
    display: inline-block;
    width: 2px;
    height: 26px;
    background: #044aa1;
    vertical-align: top;
    margin-left: 20px;
}

.title-order-number {
    display: inline-block;
    vertical-align: top;
    padding-top: 4px;
    margin-left: 10px;
}

.value-order-number {
    font-size: 13px;
    color: #2d8cf0;
    display: inline-block;
    vertical-align: top;
}

.car-container {
    padding: 10px;
    background: #fefefe;
    position: relative;
}

.receive-title {
    font-size: 14px;
    font-weight: bold;
    background: #f3f7fd;
    padding: 5px 0;
    color: #2d8cf0;
    margin: 0 10px 10px 10px;
}

.item-container {
    padding: 10px;
}

.item-content {
    border: 1px solid #a3a7af;
    padding: 5px 0 0 0;
}

.item-title {
    color: #202020;
    font-size: 13px;
    font-weight: bold;
    border-bottom: 1px solid #a3a7af;
    padding: 5px;
}

.item-price {
    padding: 15px 5px 5px 5px;
}

.item-price-child {
    text-align: center;
}

.unset-worker {
    font-size: 10px;
    display: inline-block;
    background: #d9534f;
    color: #fefefe;
    padding: 5px 10px;
    border-radius: 5px;
}

.already-worker {
    font-size: 14px;
    display: inline-block;
}

.item-footer {
    background: #f5f5f5;
    font-size: 13px;
    text-align: right;
    border-top: 1px solid #a3a7af;
    margin-top: 5px;
    padding: 5px 0;
}

.item-background {
    /*background: #f3f7fd;*/
}

.footer-button {
    color: #2d8cf0;
    margin-right: 10px;
    cursor: pointer;
}

.mater-title {
    font-weight: bold;
    color: #6c6c6c;
    text-align: center;
    font-size: 14px;
    margin-top: -20px
}

.mater-text {
    color: #6c6c6c;
    text-align: center;
    font-size: 13px;
}

.calc-title {
    font-weight: bold;
    color: #6c6c6c;
    text-align: center;
    font-size: 13px;
}

.calc-text {
    color: #6c6c6c;
    text-align: center;
    font-size: 12px;
}

.mater-remove-button {
    color: #2d8cf0;
    cursor: pointer;
}

.item-remove-button {
    color: #2d8cf0;
    cursor: pointer;
    float: right;
    margin-right: 5px;
    font-size: 13px;
    font-weight: normal;
}

.icon-edit-class {
    font-size: 20px;
    margin-left: 3px;
    cursor: pointer;
    vertical-align: middle;
}

.icon-save-class {
    font-size: 20px;
    margin-left: 3px;
    cursor: pointer;
    vertical-align: middle;
    color: #19be6b;
}

.footer-container {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 100%;
    background: #f3f7fd;
    height: 52px;
    line-height: 52px;
    padding-left: 20px;
    padding-right: 20px;
    box-shadow: 0 -2px 10px -2px rgba(0, 0, 0, 0.4);
}

.footer-title {
    font-weight: bold;
    color: #2d8cf0;
}

.footer-value {
    font-weight: bold;
    color: #041c34;
    font-size: 13px;
    margin-right: 20px;
    text-decoration: underline;
}

.footer-settlement-button {
    background: #2d8cf0;
    height: 52px;
    color: #fefefe;
    text-align: center;
    line-height: 52px;
    font-size: 18px;
    font-weight: bold;
    cursor: pointer;
    padding: 0 24px;
    position: relative;
    display: inline-block;
    float: right;
}

.price-text {
    text-align: center;
    font-weight: bold;
}

.price-desc {
    text-align: center;
    font-size: 13px;
    color: #7c7c7c;
}

.settle-line {
    background: #bcbcbc;
    height: 1px;
}

.discount-button {
    color: #2d8cf0;
    margin-left: 6px;
    cursor: pointer;
    font-size: 13px;
    font-weight: normal;
}

.percent-container {
    display: inline-block;
    background: #f3f7fd;
    border: 1px solid #e3e3e3;
    border-left: none;
    height: 34px;
    line-height: 32px;
    vertical-align: top;
    width: 26px;
    text-align: center;
}

.discount-input {
    width: 60px;
    border: 1px solid #e3e3e3;
}

.settle-info-title {
    font-size: 13px;
    color: #7c7c7c;
}

.back-button {
    border: 1px solid #e6e6e6;
    font-size: 12px;
    padding: 5px 15px;
    position: absolute;
    right: 10px;
    top: -0;
    border-radius: 3px;
    cursor: pointer;
    margin-left: 10px;
}

.font-bold {
    font-size: 14px;
    font-weight: bold;
}
</style>
